<template>
  <FlexCol gap-1 class="relative">
    <Label :label="label" :required="required" :error="error" v-if="label" />
    <div
      @focusin="hasFocus = true"
      @focusout="hasFocus = false"
      class="rounded-lg border border-slate-300 text-sm overflow-hidden bg-white h-[42px]"
      :class="[{ 'bg-slate-200': disabled }, error ? 'border-red-500' : hasFocus ? 'border-blue-900' : '', size]">
      <Flex items-center :class="classes" class="h-full">
        <Flex center class="px-2 grow border-none bg-none text-gray-700 overflow-hidden" @click="toggle()" :class="{ 'cursor-pointer': !disabled }">
          <span v-if="text">{{ text }}</span>
          <span v-else class="italic"> {{ placeholder ?? 'Selecione' }} </span>
        </Flex>
        <div class="border-l border-slate-300 h-full">
          <!-- <IconInput class="text-primary-500 bg-white" icon="fa-xmark" @click="clear()" v-if="selectedItem" /> -->
          <IconInput class="text-primary-500 bg-white" :icon="open ? 'fa-chevron-up' : 'fa-chevron-down'" @click="toggle()" />
        </div>
      </Flex>
    </div>
    <Error :message="error" v-if="error" />
    <TheTransition>
      <Card
        rounded
        border
        noSpace
        v-if="open && !disabled"
        class="absolute z-10 w-full mt-2 max-h-[168px] overflow-y-scroll text-sm"
        :class="[{ 'top-full': !up, 'bottom-full': up }]">
        <Flex justify-start items-center v-for="(item, i) in items" :key="i" class="p-2 hover:bg-slate-100 cursor-pointer" @click="select(item)">
          <span v-if="showId"> {{ item[itemValue] }} - </span>
          {{ item[itemText] }}
        </Flex>
      </Card>
    </TheTransition>
  </FlexCol>
</template>

<script setup>
import { watch, ref, computed } from 'vue'

const props = defineProps({
  label: String,
  required: Boolean,
  disabled: Boolean,
  error: Array,
  modelValue: [String, Number],
  placeholder: String,
  items: Array,
  showId: Boolean,
  basic: Boolean,
  itemValue: { type: String, default: 'value' },
  itemText: { type: String, default: 'label' },
  up: Boolean,
})

const emits = defineEmits(['update:modelValue'])
const localValue = ref(props.modelValue)
const error = ref(props.error)
const open = ref(false)
const selectedItem = ref(null)

const text = computed(() => {
  const item = props.items.find((item) => {
    if (!props.basic) {
      return item[props.itemValue] == localValue.value
    }
    return item
  })

  if (item) {
    selectedItem.value = item
    if (!props.basic) {
      return item[props.itemText]
    }
    return item
  }
  return
})

const toggle = () => {
  open.value = !open.value
}

const clear = () => {
  selectedItem.value = null
  localValue.value = null
  open.value = false
}

const select = (item) => {
  selectedItem.value = item
  if (!props.basic) {
    localValue.value = item[props.itemValue]
  } else {
    localValue.value = item
  }
  toggle()
}

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  }
)

watch(
  () => props.error,
  (newValue) => {
    error.value = newValue
  }
)

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue)
})
</script>
